module.exports = __webpack_public_path__ + "static/media/rewards.697e200c.svg";